import { ReactElement } from "react";
import CreateClient from "./pages/CreateClient";
import ClientList from "./pages/ClientList";
import ViewClient from "./pages/ViewClient";
import EditClient from "./pages/EditClient";

export interface AppRoute {
  path: string;
  element: ReactElement;
}

const clientRoutes: AppRoute[] = [
  {
    path: "/masters/client",
    element: <ClientList />,
  },
  {
    path: "/masters/client/create",
    element: <CreateClient />,
  },
  {
    path: "/masters/client/view/:id",
    element: <ViewClient />,
  },
  {
    path: "/masters/client/edit/:id",
    element: <EditClient />,
  },
];

export default clientRoutes;
